import {existingCustomerSelected, queryBearerToken} from "./UserAuthentication";
import {queryArticleOptionData} from "./ArticleData";
import {agencyServerArticleNumber, agencyServerProjectArticles, cmsArticles, getAvailableAccessoryArticles, accessoryArticles, shopArticles} from "../config/Config";
import {appInitialized} from "./AppInit";
import {putFormData} from "./FormData";
import {queryCustomerAccount, queryCustomerAccounts} from "./Accounts";
import {_accessory, _account, _article, _contract, _customerNumber} from "../selectors/GetParam";
import {addItemToCart, queryNewCart} from "./Cart";
import {SUMMARY} from "../constants/StepLabels";
import {queryCustomerResellers} from "./Resellers";
import {queryCustomerContracts} from "./Contracts";
import {getAccounts, getBaseArticle, getContracts} from "../selectors/SimpleSelectors";
import {delve} from "../util/util";
import {selectCurrentProduct} from "./BaseArticle";
import {getContractBillingPeriodNormalized} from "../selectors/Contract";
import {selectCartProperty} from "./Properties";

export const initializeAppAccessory = (initParams) => (dispatch, getState) => {

    Promise.all([

        dispatch(queryBearerToken())

    ]).then(args => {

        Promise.all([

            dispatch(queryNewCart()),
            dispatch(queryArticleOptionData(
                [
                    agencyServerArticleNumber,
                    ...cmsArticles,
                    ...shopArticles,
                    ...agencyServerProjectArticles,
                    ...accessoryArticles
                ]
            )),
            dispatch(queryCustomerContracts(_customerNumber, _contract))

        ]).then(args => {

            const postInitCalls = []

            postInitCalls.push(existingCustomerSelected())
            postInitCalls.push(addItemToCart(_accessory));

            if ('' + _accessory !== '75000' && '' + _accessory !== '75001' && '' + _accessory !== '75002' && '' + _accessory !== '75003') {
                const billingPeriodStart = getContractBillingPeriodNormalized(getState());
                postInitCalls.push(selectCartProperty('billingPeriod', billingPeriodStart));
            }

            Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {
                if (_contract) {
                    const contracts = getContracts(getState())
                    const contract = contracts[_contract]
                    const currentArticle = "" + delve(contract, "article.articleNumber")
                    if (contract && contract.sourceType === 'ACCOUNT') {
                        dispatch(selectCurrentProduct(currentArticle, contract.sourceUid))
                        dispatch(appInitialized({...initParams, initialStep: SUMMARY}))
                        dispatch(putFormData());
                    }
                } else if (_account) {

                    dispatch(queryCustomerAccount(_account)).then((args) => {
                        const accounts = getAccounts(getState());
                        const account = accounts[_account];
                        const currentArticle = delve(account, "article.articleNumber")

                        if (account) {
                            dispatch(selectCurrentProduct(currentArticle, account.uid))
                            dispatch(appInitialized({...initParams, initialStep: SUMMARY}))
                            dispatch(putFormData());
                        }
                    });
                }
            });
        })
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.Accessory.js
 **/